import { Link } from "react-router-dom";

const points = [
  "专注人物关系与动态，而非情绪化标题",
  "角色分明的归档，让新主角与当事人一目了然",
  "随核实进展滚动更新，时间线清晰可追溯",
];

export default function AboutTeaser() {
  return (
    <section className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
      <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
        <div className="relative aspect-[16/10] w-full overflow-hidden rounded-lg">
          <img
            src="https://readdy.ai/api/search-image?query=Over%20the%20shoulder%20view%20of%20an%20editorial%20newsroom%20desk%2C%20open%20notebooks%20with%20handwritten%20Chinese%20notes%2C%20printed%20newspaper%20pages%20and%20photo%20prints%20scattered%2C%20warm%20desk%20lamp%20glow%2C%20warm%20cream%20and%20deep%20ink%20tones%20with%20subtle%20vermillion%20highlights%2C%20cinematic%20journalism%20atmosphere%2C%20clean%20composition&width=1200&height=750&seq=about-editorial-desk&orientation=landscape"
            alt="编辑部办公桌上铺开的笔记与报纸素材，体现人物追踪与核实工作"
            className="h-full w-full object-cover object-top"
          />
        </div>

        <div className="rounded-lg bg-foreground-950 p-7 md:p-9">
          <p className="text-xs font-semibold tracking-widest text-background-50/60">
            ABOUT US
          </p>
          <h2 className="mt-2 font-display text-2xl font-bold text-background-50 md:text-3xl">
            焦点人物志，让热点人物关系不再扑朔迷离
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-background-50/80">
            在信息纷杂的爆料场中，我们选择回到人本身。当每一个新主角、新面孔浮出水面，我们便用档案、时间线与关系图谱，帮你理清谁是谁、谁和谁有关、事情到了哪一步。
          </p>
          <ul className="mt-5 space-y-2.5">
            {points.map((p) => (
              <li
                key={p}
                className="flex items-center gap-2.5 text-sm text-background-50/90"
              >
                <i className="ri-checkbox-circle-line text-accent-100"></i>
                {p}
              </li>
            ))}
          </ul>
          <Link
            to="/guanyu"
            className="mt-6 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-background-200"
          >
            了解我们的立场与原则
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}